<template>
	<v-navigation-drawer
		v-model="drawer"
		class="navigation-drawer elevation-3"
		:permanent="$vuetify.breakpoint.mdAndUp"
		:expand-on-hover="$vuetify.breakpoint.mdAndUp"
	>
		<div class="navigation-drawer-content">
			<template v-if="$vuetify.breakpoint.smAndDown">
				<v-list-item>
					<v-list-item-avatar color="primary" class="white--text">
						{{ Initials }}
					</v-list-item-avatar>

					<v-list-item-content>
						<v-list-item-title>
							{{ $store.state.acount.user.name }}
						</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-divider></v-divider>
			</template>

			<!-- Slot(Default)-->
			<slot> </slot>

			<div class="navigation-drawer-content-bottom">
				<slot name="bottom"></slot>
			</div>
		</div>
	</v-navigation-drawer>
</template>

<script>
import { EventBus } from "@/main";

export default {
	name: "Navigation",

	data() {
		return {
			drawer: false,
		};
	},

	created() {
		EventBus.$on("navigationToggle", () => {
			this.drawer = !this.drawer;
		});
	},

	methods: {
		hasRol(rolIdRequired) {
			if (this.$store.state.authenticated) {
				if (
					this.$store.state.acount.user.roles.find(
						(rol) => rol.id === rolIdRequired
					)
				) {
					return true;
				}
			}

			return false;
		},

		logout() {
			EventBus.$emit("Logout");
		},
	},

	computed: {
		Initials() {
			try {
				var initials = this.$store.state.acount.user.name.split(" ");

				return `${initials[0][0]}${initials[1][0]}`;
			} catch (e) {
				return "";
			}
		},
	},
};
</script>

<style lang="css" scoped>
.navigation-drawer {
	z-index: 45;
	position: fixed;
	top: 90px !important;
	transition: all 0.3s;
}

.navigation-drawer-content {
	height: calc(100% - 100px);
	position: relative;
}

.navigation-drawer-content-bottom {
	position: absolute;
	width: 100%;
	bottom: 0;
}
</style>
